import React, { Component } from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getLanguage} from '../../store/apiWrapper';
import { withLocalize } from "react-localize-redux";
import "./richTextEditor.scss";

class RichTextEditor extends Component {

    modules = {
        toolbar: [
          [{ 'size': [] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          [{ 'align': [] }],
          [{ 'color': [] }, { 'background': [] }],
          ['link', 'image'],
          ['clean']
        ],
      }

    render() {
        return (
            <ReactQuill
                className={getLanguage()}
                value={this.props.value}
                onChange={(value) => this.props.onChange(value)}
                theme={"snow"}
                modules={this.modules}
            />
        )
    }
}

export default withLocalize(RichTextEditor);
